// repo/primary-care-connect/frontend/src/pages/public/Legal/ClinicAdminAgreement/ClinicAdminAgreementPage.tsx
import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../../../components/SEO/SEO";

export default function ClinicAdminAgreementPage() {
  return (
    <div
      style={{
        maxWidth: 900,
        margin: "0 auto",
        padding: "32px 16px",
        fontFamily: "system-ui, -apple-system, Segoe UI, sans-serif",
        lineHeight: 1.6,
      }}
    >
      <SEO
        title="Clinic Admin Agreement"
        description="Terms and responsibilities for Clinic Admin access to the AcceptingMD provider portal."
        noIndex={true}
      />
      <div style={{ marginBottom: 16 }}>
        <Link to="/portal/request-access" style={{ textDecoration: "none" }}>
          ← Back to Request Access
        </Link>
      </div>

      <h1 style={{ marginTop: 0 }}>Clinic Admin Agreement</h1>

      <p style={{ color: "#6b7280", marginTop: 8 }}>
        Last updated: February 7, 2026
      </p>

      <p>
        This Clinic Admin Agreement (“Agreement”) applies when you request and/or
        receive Clinic Admin access in the AcceptingMD portal (“AcceptingMD”,
        “we”, “us”, “our”). By checking the “I agree” box during the Request
        Access process, you confirm you have read and agree to the terms below.
      </p>

      <h2>1) Authority and eligibility</h2>
      <ul>
        <li>
          You confirm you are authorized to act on behalf of the clinic you are
          requesting access for.
        </li>
        <li>
          You confirm the information you submit in your request is accurate and
          complete to the best of your knowledge.
        </li>
      </ul>

      <h2>2) Clinic Admin responsibilities</h2>
      <ul>
        <li>
          You are responsible for maintaining accurate clinic profile
          information, including clinic contact details and operational
          information.
        </li>
        <li>
          You are responsible for managing clinic access, including inviting
          providers, assigning roles, and removing access when appropriate.
        </li>
        <li>
          You agree to use AcceptingMD only for legitimate clinic administration
          and patient intake workflows supported by the platform.
        </li>
      </ul>

      <h2>3) Account security</h2>
      <ul>
        <li>
          You must keep your account credentials secure and not share access with
          unauthorized persons.
        </li>
        <li>
          You must notify us promptly if you believe your account or clinic
          access has been compromised.
        </li>
      </ul>

      <h2>4) Verification and governance</h2>
      <ul>
        <li>
          You understand Clinic Admin access is granted only after manual review
          and verification.
        </li>
        <li>
          We may contact you and/or the clinic using the information provided to
          verify legitimacy, authority, and clinic details.
        </li>
        <li>
          We may suspend or revoke access if we identify misuse, unauthorized
          access, inaccurate information, or policy violations.
        </li>
      </ul>

      <h2>5) Privacy, confidentiality, and permitted use</h2>
      <ul>
        <li>
          You agree to handle any information accessed through the portal
          responsibly and to respect privacy and confidentiality obligations.
        </li>
        <li>
          You agree not to use AcceptingMD to collect, store, or disclose
          information in ways that are not required for clinic administration and
          the intended workflow of the platform.
        </li>
      </ul>

      <h2>6) Additional clinic admins</h2>
      <p>
        You acknowledge that a clinic may have multiple Clinic Admins. Clinic
        Admin access can be added or replaced based on clinic governance needs,
        subject to platform rules and approval workflows.
      </p>

      <h2>7) Changes</h2>
      <p>
        We may update this Agreement from time to time. The version presented at
        the time of your acceptance governs your request. Updated terms apply
        prospectively for new acceptances.
      </p>

      <h2>8) Contact</h2>
      <p>
        If you have questions about this Agreement or your Clinic Admin request,
        please contact the AcceptingMD team through the support channels listed
        on our public site.
      </p>

      <div style={{ marginTop: 28, paddingTop: 16, borderTop: "1px solid #e5e7eb" }}>
        <p style={{ margin: 0, color: "#6b7280" }}>
          January 2026
        </p>
      </div>
    </div>
  );
}
